import FteModeToggle from "./FteModeToggle";

type FteDataSidebarContentProps = {
  /** Storybook composites only: omit toggle control from layout snapshots. */
  storybookToggleStub?: boolean;
};

const FteDataSidebarContent = ({
  storybookToggleStub = false,
}: FteDataSidebarContentProps) => (
  <FteModeToggle storybookToggleStub={storybookToggleStub} />
);

export default FteDataSidebarContent;
